import gql from 'graphql-tag';

const CUSTOMER_NAMES = gql`
  query Query($query: String!) {
    customerNames(query: $query) {
      customerName
    }
  }
`;

export default CUSTOMER_NAMES;
